export * from './lib/portal-footer.model';
